import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserContextService } from '../providers/services/user-context.service';
import { OtpService } from '../providers/services/otp.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private userContextService: UserContextService,
    private otpService: OtpService
  ) {}

  /**
   * @function canActivate
   * validateForm method used to check the authentication on routing guard
   */
  async canActivate(): Promise<boolean> {
    const isAuthenticated = this.userContextService.isAuthenticated();
    const isLoggedIn = this.otpService.isLoggedIn();
    if (isAuthenticated && isLoggedIn) {
      if (this.router.url !== '/home') {
        this.router.navigate(['/home'], { replaceUrl: true });
      }
      return false;
    }
    return true;
  }
}
